import Link from "next/link";
import React from "react";

const orderLink = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/orders`;
const storeReceiptLink = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/store-receipts`;
export const JLProductCodeDescription = ({ purchaseType = "" }) => {
  return purchaseType === "online" ? (
    <span>
      8-digit number found on your&nbsp;
      <Link href={orderLink} rel="noopener noreferrer" target="_blank">
        Order Details
      </Link>
      &nbsp;or confirmation email.
    </span>
  ) : (
    <span>8 numbers, found on your receipt next to the product name</span>
  );
};

export const OrderNumberDescription = () => {
  return (
    <span>
      9 numbers and starts with 4 or 5, found on your&nbsp;
      <Link href={orderLink} rel="noopener noreferrer" target="_blank">
        Order Details
      </Link>
      &nbsp;or confirmation email.
    </span>
  );
};

export const ProductColorDescription = ({ purchaseType = "" }) => {
  if (purchaseType === "online") {
    return (
      <span>
        You can find the colour on your&nbsp;
        <Link href={orderLink} rel="noopener noreferrer" target="_blank">
          Order Details
        </Link>
        .
      </span>
    );
  }
  return null;
};

export const YourReceiptDescription = () => {
  return (
    <div>
      <p>
        Please upload your receipt. Make sure the barcode, barcode number, date, transaction number and product code are
        clear in the photo.
      </p>
      <p>
        If you’re a My John Lewis member, you can see your shop receipts in your&nbsp;
        <Link href={storeReceiptLink} rel="noopener noreferrer" target="_blank">
          online account
        </Link>
        . If you don’t have a paper receipt because you paid away from the till, include a screenshot from your&nbsp;
        <Link href={orderLink} rel="noopener noreferrer" target="_blank">
          Order Details
        </Link>
        &nbsp;or order confirmation email.
      </p>
      <p>Maximum 3 photos</p>
    </div>
  );
};

export const LowerPricePhotosDescription = () => {
  return (
    <>
      <p>The price may change again so this will help us check. The pictures must show the item and price clearly.</p>
      <p>Maximum 3 photos</p>
    </>
  );
};

export const OnlinePurchasePhoneDescription = () => {
  return (
    <>
      <p>We’ll only phone you if we need to check something about your request.</p>
      <p>Your details will not be used for marketing purposes.</p>
    </>
  );
};

export const ShopPurchasePhoneDescription = () => {
  return (
    <>
      <p>We’ll call you on this number to process your refund.</p>
      <p>Your details will not be used for marketing purposes.</p>
    </>
  );
};
